import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContentTitle,
  ModalSheetFooterButtonGroup,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentBlock,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import styles from './RemoveCouponAsAdminDialog.module.css'
import { byDesign } from '@/infra/design'
import imgConfirmActionUrl from '@/assets/misc/img_confirm-action.svg'
import WorkspaceRolesIllustration from '@/components/SpotIllustration/WorkspaceRolesIllustration'

export interface RemoveCouponAsAdminDialogProps {
  showing: boolean
  couponDisplay: string
  isRemovePending: boolean
  onClose: () => unknown
  onRemoveCoupon: () => unknown
  submitButtonTestId?: string
}

export function RemoveCouponAsAdminDialog({
  showing,
  couponDisplay,
  isRemovePending,
  onClose,
  onRemoveCoupon,
  submitButtonTestId,
}: RemoveCouponAsAdminDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isRemovePending ? undefined : onClose}
      disableCloseOnEsc
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentTitle>
            <ModalSheetContentIllustration
              src={imgConfirmActionUrl}
              illustration={byDesign(undefined, WorkspaceRolesIllustration)}
              alt="Illustration of a girl with her laptop and a plus symbol"
            />
            You are about to remove a coupon
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Are you sure you want to remove coupon code &nbsp;
            <span className={styles.emphasize}>{couponDisplay}</span>
            &nbsp; from the job? Discount will no longer be applied.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Close"
            isDisabled={isRemovePending}
            variant="default"
            onPress={onClose}
          />
          <Button
            label="Remove Coupon"
            variant="destructive"
            isPending={isRemovePending}
            testId={submitButtonTestId}
            onPress={onRemoveCoupon}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
